@if (isOpen || shouldVirtuallyOpen) {
  <div
    animate.enter="slide-in"
    animate.leave="slide-out"
    class="ice-accordion-content-card-body"
    [ngClass]="{ 'hide-content': !isOpen && shouldVirtuallyOpen }"
  >
    <div class="inner-body">
      @if (!shouldVirtuallyOpen) {
        <ng-template [ngTemplateOutlet]="lazyContent && lazyContent.content" />
      }
      <ng-content />
    </div>
  </div>
}
